<template>
  <div class="page--create-review">
    <GTopAds />
    <div v-if="screen.width > 740" class="show-desktop">
      <div class="head">
        <h2 class="heading">
          <img src="/assets/img/icons/write-review-circle-v2.svg" class="icon icon__write-review" alt="SOCO" />Write
          Review
        </h2>

        <div v-if="!isLoadingProduct" class="product-display">
          <div class="product-display__thumb">
            <img
              v-if="productSelected.images"
              :src="productSelected.images[0].url"
              onerror="this.src='/assets/img/dummy_product.svg'"
              :alt="productSelected.name"
            />
            <img v-else src="/assets/img/dummy_product.svg" alt="SOCO" />
          </div>

          <div class="product-display__content">
            <h5 v-if="productSelected.brand" class="manufacture-name">{{ productSelected.brand.name }}</h5>
            <p class="product-name">{{ productSelected.name }}</p>
            <p v-if="productSelected.selected_combination" class="attribute-name">
              {{ productSelected.selected_combination.name | stripHTML }}
            </p>
            <div v-if="user.is_expert_reviewer" class="trusted-review">
              <img src="/assets/img/expert-review-check-icon.svg" height="18" width="18" alt="icon-expert" />
            </div>
            <div v-else-if="haveUserPurchasedProduct" class="trusted-review">
              <img src="/assets/img/icon-shopper.svg" height="18" width="18" alt="shopper" />
            </div>
            <a href="" class="text-change-product" @click.prevent="openModal">Change Product</a>
          </div>
        </div>
        <div v-else class="product-display" style="padding: 0">
          <GFMP key="col3-GFMP" :styles="{ height: '126px', borderRadius: '4px' }" />
        </div>
      </div>

      <div class="container content-create-review">
        <form v-if="productId" class="form-write-review" @submit.prevent>
          <div v-if="!isLoadingProduct" class="row">
            <div class="col-md-12 col-xs-12">
              <div class="form-input-group">
                <div v-if="$SO.size(productCategory)" class="form-group">
                  <label class="form-label">Give Ratings <span class="input-mandatory">*</span></label>
                  <div class="list-rating">
                    <ReviewRating
                      v-for="(rating, key) in ratingTypes"
                      :key="key"
                      :title="rating"
                      :name="rating"
                      @getRating="setRating"
                    >
                    </ReviewRating>
                  </div>
                  <input v-model="allRating" v-validate="'required'" type="hidden" name="rating" />
                  <p v-show="errors.has('rating')" class="text-error">Semua rating belum diisi</p>

                  <div class="average-rating-wrapper">
                    <div class="average-rating">
                      <h4 class="average-rating__heading">Average Rating</h4>
                      <div class="average-rating__value">
                        <img v-if="averageRating" src="/assets/img/icons/rating-big.svg" alt="icon-rating" />
                        <img v-else src="/assets/img/icons/rating-big-disabled.svg" alt="icon-rating" />
                        {{ averageRating }}
                      </div>
                      <div class="average-rating__caption">
                        {{ captionRating(averageRating) }}
                      </div>
                    </div>
                    <div class="average-rating__divider"></div>
                  </div>
                </div>

                <div class="divider"></div>

                <div class="form-group">
                  <label class="form-label">Write A Review <span class="input-mandatory">*</span></label>
                  <span class="text-helped-counter" :class="{ passed: temp.contentReview.length >= 150 }"
                    >{{ temp.contentReview.length }} / <b>150</b></span
                  >
                  <textarea
                    v-model="temp.contentReview"
                    v-validate="'required|min:150'"
                    :placeholder="txtPlaceholder"
                    class="form-control textarea-review"
                    name="content_review"
                    data-vv-as="review"
                    @input="onInputContentReview"
                  ></textarea>
                  <p v-show="errors.has('content_review')" class="text-error">{{ errors.first('content_review') }}</p>
                </div>

                <div class="divider"></div>

                <div class="form-group">
                  <label class="form-label">How long have you been using this product</label>
                  <div class="row">
                    <div class="col-md-3 col-xs-6">
                      <label class="radio-donut m-b-16">
                        <input v-model="temp.durationUsed" type="radio" name="type" value="Less than 1 Week" /> Less
                        than 1 week
                        <span></span>
                      </label>
                      <label class="radio-donut m-b-16">
                        <input v-model="temp.durationUsed" type="radio" name="type" value="1 Week - 1 Month" /> 1 week -
                        1 Month
                        <span></span>
                      </label>
                    </div>
                    <div class="col-md-3 col-xs-6">
                      <label class="radio-donut m-b-16">
                        <input v-model="temp.durationUsed" type="radio" name="type" value="1 - 3 Months" /> 1 - 3 Months
                        <span></span>
                      </label>
                      <label class="radio-donut m-b-16">
                        <input v-model="temp.durationUsed" type="radio" name="type" value="3 - 6 Months" /> 3 - 6 Months
                        <span></span>
                      </label>
                    </div>
                    <div class="col-md-3 col-xs-6">
                      <label class="radio-donut m-b-16">
                        <input v-model="temp.durationUsed" type="radio" name="type" value="6 Months - 1 Year" /> 6
                        Months - 1 Year
                        <span></span>
                      </label>
                      <label class="radio-donut m-b-16">
                        <input v-model="temp.durationUsed" type="radio" name="type" value="More than 1 Year" /> More
                        than 1 Year
                        <span></span>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="divider"></div>

                <div class="form-group">
                  <label class="form-label">
                    Add Photo <span class="icon-small" @click="openTncPhoto">&#9432;</span>
                  </label>
                  <div class="custom-input-product-shot">
                    <span class="text-helped">Add photos (max. 6 photos & max. 5 MB).</span>
                    <!-- <button type="button" class="btn btn_icon-camera" @click.prevent="openModalUploadPhoto" v-if="productShot.length < 6">ADD PHOTOS</button> -->
                  </div>

                  <ul class="list-product-shot" :class="{ filled: productShot.length }">
                    <li
                      v-if="productShot.length < 6 && !openOnceTnc"
                      class="product-shot product-shot--add-photos"
                      @click.prevent="openTncPhoto"
                    ></li>
                    <li
                      v-else-if="productShot.length < 6 && openOnceTnc"
                      class="product-shot product-shot--add-photos"
                      @click.prevent="openModalUploadPhoto"
                    ></li>
                    <template v-if="productShot.length">
                      <li v-for="(productPhoto, key) in productShot" :key="key" class="product-shot">
                        <img :src="productPhoto.file" class="product-shot__img" alt="SOCO" />
                        <a href="" class="product-shot__info" @click.prevent="editProductShot(key)">Edit caption</a>
                        <a href="" class="product-shot__remove" @click.prevent="confirmationRemovePhoto(key)"></a>
                      </li>
                    </template>
                  </ul>
                </div>

                <div class="divider"></div>

                <!-- <div class="form-group custom-input-tagging">
									<label class="form-label">Add tag </label>
									<div class="fieldarea fieldarea--multiselect fieldarea--multiselect--tag">
										<Multiselect
											v-model="temp.tag"
											id="ajax"
											label="name"
											placeholder=""
											open-direction="bottom"
											:options="options.tag"
											:multiple="true"
											:searchable="true"
											:loading="state.tag.isLoading"
											:internal-search="false"
											:clear-on-select="true"
											:close-on-select="true"
											:options-limit="300"
											:max-height="600"
											:show-no-results="true"
											:hide-selected="true"
											:showNoOptions="false"
											@search-change="searchTag"
											:show-labels="false"
											track-by="name"
											ref="multiselect"
											@select="onSelected"
										>
										    <template slot="clear" slot-scope="props">
										      <div class="multiselect__clear" v-if="optionTags.length === 0" @mousedown.prevent.stop="clearAll"></div>
										    </template>
										    <span slot="noResult">Tag not found</span>
										</Multiselect>
									</div>
								</div> -->

                <div v-if="$SO.size(productSelected)" class="form-group section-opinion">
                  <div class="row">
                    <div class="col-md-5 col-xs-12 recommend">
                      <img :src="pathEmojiRecomended" class="section-opinion__emoji" alt="SOCO" />

                      <p class="text">Will you recommend this product? <span class="input-mandatory">*</span></p>

                      <div id="is_recommended" class="radio-button">
                        <div class="radio-button__option" :class="{ active: temp.isRecomended === 'yes' }">
                          <input
                            id="recommend-yes"
                            v-model="temp.isRecomended"
                            v-validate="'required'"
                            class="text"
                            name="is_recommended"
                            type="radio"
                            value="yes"
                            data-vv-as="recommend"
                          />
                          <label for="recommend-yes" class="radio-button__label">Yes Absolutely !</label>
                        </div>
                        <div class="radio-button__option" :class="{ active: temp.isRecomended === 'no' }">
                          <input
                            id="recommend-no"
                            v-model="temp.isRecomended"
                            v-validate="'required'"
                            class="text"
                            name="is_recommended"
                            type="radio"
                            value="no"
                            data-vv-as="recommend"
                          />
                          <label for="recommend-no" class="radio-button__label">No</label>
                        </div>
                      </div>
                      <p v-show="errors.has('is_recommended')" class="text-error">
                        {{ errors.first('is_recommended') }}
                      </p>
                    </div>

                    <div class="col-md-7 col-xs-12 repurchase">
                      <img :src="pathEmojiRepurchase" class="section-opinion__emoji" alt="SOCO" />

                      <p class="text">Will you repurchase this product ? <span class="input-mandatory">*</span></p>

                      <div id="is_repurchase" class="radio-button">
                        <div class="radio-button__option" :class="{ active: temp.isRepurchase === 'yes' }">
                          <input
                            id="repurchase-yes"
                            v-model="temp.isRepurchase"
                            v-validate="'required'"
                            class="text"
                            name="is_repurchase"
                            type="radio"
                            value="yes"
                            data-vv-as="repurchase"
                          />
                          <label for="repurchase-yes" class="radio-button__label">Yes Absolutely !</label>
                        </div>
                        <div class="radio-button__option" :class="{ active: temp.isRepurchase === 'no' }">
                          <input
                            id="repurchase-no"
                            v-model="temp.isRepurchase"
                            v-validate="'required'"
                            class="text"
                            name="is_repurchase"
                            type="radio"
                            value="no"
                            data-vv-as="repurchase"
                          />
                          <label for="repurchase-no" class="radio-button__label">No</label>
                        </div>
                        <div class="radio-button__option" :class="{ active: temp.isRepurchase === 'maybe' }">
                          <input
                            id="repurchase-maybe"
                            v-model="temp.isRepurchase"
                            v-validate="'required'"
                            class="text"
                            name="is_repurchase"
                            type="radio"
                            value="maybe"
                            data-vv-as="repurchase"
                          />
                          <label for="repurchase-maybe" class="radio-button__label">Maybe</label>
                        </div>
                      </div>
                      <p v-show="errors.has('is_repurchase')" class="text-error">{{ errors.first('is_repurchase') }}</p>
                    </div>
                  </div>
                </div>

                <div v-if="isAdminRole" class="form-group custom-input-fake-user">
                  <label class="form-label">Create Review as <span class="input-mandatory">*</span></label>
                  <span class="text-helped text-helped--copywriting-login-admin"
                    >You are logged in as admin, you can select and act as another user to review this product.</span
                  >
                  <div class="fieldarea fieldarea--multiselect">
                    <Multiselect
                      v-model="temp.fakeUser"
                      v-validate="'required'"
                      :options="options.fakeUser"
                      placeholder="Type to search user"
                      label="name"
                      track-by="name"
                      :loading="state.fakeUser.isLoading"
                      :show-labels="false"
                      open-direction="bottom"
                      :searchable="true"
                      :internal-search="false"
                      :clear-on-select="false"
                      :close-on-select="true"
                      :options-limit="300"
                      :max-height="600"
                      :show-no-results="false"
                      :hide-selected="true"
                      name="user"
                      @search-change="searchUser"
                    >
                      <span slot="noResult">User not found</span>
                    </Multiselect>
                  </div>
                  <p v-show="errors.has('user')" class="text-error">{{ errors.first('user') }}</p>
                </div>

                <div class="create-review-text">
                  <loader-spin v-if="!showModalConfirmationPublish && state.onProgressSubmit"></loader-spin>
                  <button
                    v-else
                    type="button"
                    class="btn btn_black btn_publish"
                    :class="{ disabled: disabledPublishDesktop }"
                    :disabled="disabledPublishDesktop"
                    @click.prevent="confirmation"
                  >
                    Publish
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="row">
            <div class="col-md-12 col-xs-12">
              <div class="form-input-group">
                <div class="list-rating">
                  <div v-for="i in 5" :key="i" class="field" style="padding: 0 15px">
                    <GFMP :key="`list-rating-${i}`" :styles="{ height: '60px', borderRadius: '4px' }" />
                  </div>
                </div>

                <GFMP key="averageRating-GFMP" :styles="{ height: '20px' }" />

                <GFMP key="col1-GFMP" :styles="{ height: '220px', marginBottom: '24px' }" />

                <GFMP key="col2-GFMP" :styles="{ height: '160px' }" />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div v-if="screen.width <= 740" class="show-mobile">
      <GModal class="modal--full-fixed">
        <div slot="header">
          <button type="button" class="close" aria-label="Close">
            <img src="/assets/img/icons/back.svg" alt="SOCO" @click.prevent="backStep" />
          </button>
          <h2 class="modal-heading modal-heading__header">{{ copywritingHeadingMobile }}</h2>
        </div>
        <div slot="body">
          <div v-if="!screen.isDesktop" class="parent-progress">
            <span class="counter-progress">{{ captionProgress }}</span>
            <div class="progress">
              <div class="progress-bar" :style="{ width: widthProgress }"></div>
            </div>
          </div>
          <div
            v-show="layerSteps.give_rating"
            class="give-rating-state"
            :class="{ 'p-bottom-90': allRating && !screen.isDesktop }"
          >
            <div v-if="!isLoadingProduct">
              <div
                class="wallpaper"
                :class="{
                  'wallpaper--bigger': $SO.size(productCategory) && $SO.size(productCategory.rating_types) > 4,
                }"
              ></div>
              <div class="head">
                <div class="product-display">
                  <div class="product-display__thumb">
                    <img
                      v-if="productSelected.images"
                      :src="productSelected.images[0].url"
                      onerror="this.src='/assets/img/dummy_product.svg'"
                      :alt="productSelected.name"
                    />
                    <img v-else src="/assets/img/dummy_product.svg" alt="SOCO" />
                  </div>
                  <div class="product-display__content">
                    <h5 v-if="productSelected.brand" class="manufacture-name">{{ productSelected.brand.name }}</h5>
                    <p class="product-name">{{ convertName(productSelected.name) }}</p>
                    <p v-if="productSelected.selected_combination" class="attribute-name">
                      {{ productSelected.selected_combination.name | stripHTML }}
                    </p>
                    <a href="" class="text-change-product" @click.prevent="openModal">Change Product</a>
                    <!-- <div
                      v-if="
                        (!productSelected.is_reviewed &&
                          productSelected.selected_combination &&
                          productSelected.selected_combination.is_verified_purchase) ||
                        (!productSelected.is_reviewed &&
                          !productSelected.selected_combination &&
                          productSelected.combinations &&
                          productSelected.combinations.length &&
                          productSelected.combinations[0].is_verified_purchase)
                      "
                      class="trusted-review"
                    >
                      <SvgImg
                        id="trusted-review"
                        name="trusted-review"
                        class="trusted-review__icon"
                        width="14"
                        height="12"
                      />
                    </div> -->
                    <div v-if="user.is_expert_reviewer" class="trusted-review">
                      <img src="/assets/img/expert-review-check-icon.svg" height="18" width="18" alt="icon-expert" />
                    </div>
                    <div v-else-if="haveUserPurchasedProduct" class="trusted-review">
                      <img src="/assets/img/icon-shopper.svg" height="18" width="18" alt="shopper" />
                    </div>
                  </div>
                </div>
                <h2 class="text-give-rating">Bagaimana penilaianmu terhadap produk ini?</h2>
                <div v-if="$SO.size(productCategory)" class="list-rating">
                  <ReviewRating
                    v-for="(rating, key) in productCategory.rating_types"
                    :key="key"
                    :title="rating"
                    :name="rating"
                    @getRating="setRating"
                  >
                  </ReviewRating>
                </div>
                <input v-model="allRating" v-validate="'required'" type="hidden" name="rating" />
                <p v-show="errors.has('rating')" class="text-error">Semua rating belum diisi</p>
              </div>
            </div>
            <div v-else>
              <div class="wallpaper"></div>
              <div class="head">
                <div class="product-display" style="padding: 0">
                  <GFMP key="col3-GFMP" :styles="{ height: '126px', borderRadius: '4px' }" />
                </div>
                <GFMP key="col1-GFMP" :styles="{ height: '100px', marginBottom: '16px' }" />
                <GFMP key="col2-GFMP" :styles="{ height: '200px' }" />
              </div>
            </div>
          </div>
          <div v-show="layerSteps.write_review" class="write-review-state">
            <div class="new-wrapper-rating">
              <div class="average-rating">
                <div class="average-rating__left">
                  <h4 class="average-rating__heading">Your Rating</h4>
                  <div class="average-rating__caption">
                    {{ captionRating(averageRating) }}
                  </div>
                </div>
                <div class="average-rating__value">
                  <img v-if="averageRating" src="/assets/img/icons/rating-big.svg" alt="icon-rating" />
                  <img v-else src="/assets/img/icons/rating-big-disabled.svg" alt="icon-rating" />
                  {{ averageRating }}
                </div>
              </div>
            </div>
            <div class="p-16">
              <div class="form-group">
                <label class="form-label">Write A Review <span class="input-mandatory">*</span></label>
                <span class="text-helped-counter" :class="{ passed: temp.contentReview.length >= 150 }"
                  >{{ temp.contentReview.length }} / <b>150</b></span
                >
                <textarea
                  v-model="temp.contentReview"
                  v-validate="'required|min:150'"
                  :placeholder="txtPlaceholder"
                  name="content_review"
                  class="form-control textarea-review"
                  data-vv-as="review"
                  @input="onInputContentReview"
                >
                </textarea>
                <p v-show="errors.has('content_review')" class="text-error">{{ errors.first('content_review') }}</p>
              </div>
              <div class="divider"></div>
              <div class="form-group section-using-product">
                <label class="form-label">How long have you used this product?</label>
                <div class="row">
                  <div class="radio-button">
                    <div class="radio-button__option" :class="{ active: temp.durationUsed === 'Less than 1 Week' }">
                      <input
                        id="less-than-1-week"
                        v-model="temp.durationUsed"
                        class="text"
                        name="type"
                        type="radio"
                        value="Less than 1 Week"
                      />
                      <label for="less-than-1-week" class="radio-button__label">Less than 1 week</label>
                    </div>
                    <div class="radio-button__option" :class="{ active: temp.durationUsed === '1 Week - 1 Month' }">
                      <input
                        id="1-week-1-month"
                        v-model="temp.durationUsed"
                        class="text"
                        name="type"
                        type="radio"
                        value="1 Week - 1 Month"
                      />
                      <label for="1-week-1-month" class="radio-button__label">1 Week - 1 Month</label>
                    </div>
                    <div class="radio-button__option" :class="{ active: temp.durationUsed === '1 - 3 Months' }">
                      <input
                        id="1-3-months"
                        v-model="temp.durationUsed"
                        class="text"
                        name="type"
                        type="radio"
                        value="1 - 3 Months"
                      />
                      <label for="1-3-months" class="radio-button__label">1 - 3 Months</label>
                    </div>
                    <div class="radio-button__option" :class="{ active: temp.durationUsed === '3 - 6 Months' }">
                      <input
                        id="3-6-months"
                        v-model="temp.durationUsed"
                        class="text"
                        name="type"
                        type="radio"
                        value="3 - 6 Months"
                      />
                      <label for="3-6-months" class="radio-button__label">3 - 6 Months</label>
                    </div>
                    <div class="radio-button__option" :class="{ active: temp.durationUsed === '6 Months - 1 Year' }">
                      <input
                        id="6-months-1-year"
                        v-model="temp.durationUsed"
                        class="text"
                        name="type"
                        type="radio"
                        value="6 Months - 1 Year"
                      />
                      <label for="6-months-1-year" class="radio-button__label">6 Months - 1 Year</label>
                    </div>
                    <div class="radio-button__option" :class="{ active: temp.durationUsed === 'More than 1 Year' }">
                      <input
                        id="more-than-1-year"
                        v-model="temp.durationUsed"
                        class="text"
                        name="type"
                        type="radio"
                        value="More than 1 Year"
                      />
                      <label for="more-than-1-year" class="radio-button__label">More than 1 Year</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="divider"></div>
              <div class="form-group">
                <label class="form-label form-label-photo">
                  Add photo <span class="icon-small" @click="openTncPhoto">&#9432;</span>
                </label>
                <div class="custom-input-product-shot">
                  <span class="text-helped">Add photos (max. 6 photos & max. 5 MB).</span>
                  <!-- <button type="button" class="btn btn_icon-camera" @click.prevent="openModalUploadPhoto" v-if="productShot.length < 6">ADD PHOTOS</button> -->
                </div>

                <ul class="list-product-shot" :class="{ filled: productShot.length }">
                  <template v-if="productShot.length">
                    <li v-for="(productPhoto, key) in productShot" :key="key" class="product-shot">
                      <img :src="productPhoto.file" class="product-shot__img" alt="SOCO" />
                      <a href="" class="product-shot__info" @click.prevent="editProductShot(key)">Edit Caption</a>
                      <a href="" class="product-shot__remove" @click.prevent="confirmationRemovePhoto(key)"></a>
                    </li>
                  </template>
                  <li
                    v-if="productShot.length < 6 && !openOnceTnc"
                    class="product-shot product-shot--add-photos"
                    @click.prevent="openTncPhoto"
                  ></li>
                  <li
                    v-else-if="productShot.length < 6 && openOnceTnc"
                    class="product-shot product-shot--add-photos"
                    @click.prevent="openModalUploadPhoto"
                  ></li>
                </ul>
              </div>
              <div class="divider"></div>
              <div class="form-group section-opinion">
                <label class="form-label form-label-recommend">Will you recommend this product?</label>
                <div class="row">
                  <div id="is_recommended" class="radio-button">
                    <div class="radio-button__option" :class="{ active: temp.isRecomended === 'yes' }">
                      <input
                        id="recommend-yes"
                        v-model="temp.isRecomended"
                        v-validate="'required'"
                        class="text"
                        name="is_recommended"
                        type="radio"
                        value="yes"
                        data-vv-as="recommend"
                      />
                      <label for="recommend-yes" class="radio-button__label">
                        <img :src="pathEmojiRecomendedYes" class="section-opinion__emoji" alt="SOCO" /> Yes Absolutely !
                      </label>
                    </div>
                    <div class="radio-button__option" :class="{ active: temp.isRecomended === 'no' }">
                      <input
                        id="recommend-no"
                        v-model="temp.isRecomended"
                        v-validate="'required'"
                        class="text"
                        name="is_recommended"
                        type="radio"
                        value="no"
                        data-vv-as="recommend"
                      />
                      <label for="recommend-no" class="radio-button__label">
                        <img :src="pathEmojiRecomendedNo" class="section-opinion__emoji" alt="SOCO" /> No
                      </label>
                    </div>
                  </div>
                  <p v-show="errors.has('is_recommended')" class="text-error">{{ errors.first('is_recommended') }}</p>
                </div>
              </div>
              <div class="divider"></div>
              <div class="form-group section-opinion">
                <label class="form-label form-label-recommend">Will you repurchase this product ? </label>
                <div class="row">
                  <div id="is_repurchase" class="radio-button">
                    <div class="radio-button__option" :class="{ active: temp.isRepurchase === 'yes' }">
                      <input
                        id="repurchase-yes"
                        v-model="temp.isRepurchase"
                        v-validate="'required'"
                        class="text"
                        name="is_repurchase"
                        type="radio"
                        value="yes"
                        data-vv-as="repurchase"
                      />
                      <label for="repurchase-yes" class="radio-button__label">
                        <img :src="pathEmojiRepurchaseYes" class="section-opinion__emoji" alt="SOCO" />Yes
                      </label>
                    </div>
                    <div class="radio-button__option" :class="{ active: temp.isRepurchase === 'no' }">
                      <input
                        id="repurchase-no"
                        v-model="temp.isRepurchase"
                        v-validate="'required'"
                        class="text"
                        name="is_repurchase"
                        type="radio"
                        value="no"
                        data-vv-as="repurchase"
                      />
                      <label for="repurchase-no" class="radio-button__label">
                        <img :src="pathEmojiRepurchaseNo" class="section-opinion__emoji" alt="SOCO" />No !
                      </label>
                    </div>
                    <div class="radio-button__option" :class="{ active: temp.isRepurchase === 'maybe' }">
                      <input
                        id="repurchase-maybe"
                        v-model="temp.isRepurchase"
                        v-validate="'required'"
                        class="text"
                        name="is_repurchase"
                        type="radio"
                        value="maybe"
                        data-vv-as="repurchase"
                      />
                      <label for="repurchase-maybe" class="radio-button__label">
                        <img :src="pathEmojiRepurchaseMaybe" class="section-opinion__emoji" alt="SOCO" />Maybe
                      </label>
                    </div>
                  </div>
                  <p v-show="errors.has('is_repurchase')" class="text-error">{{ errors.first('is_repurchase') }}</p>
                </div>
              </div>
              <div class="divider"></div>
              <div v-if="isAdminRole" class="form-group custom-input-fake-user">
                <label class="form-label">Create Review as <span class="input-mandatory">*</span></label>
                <span class="text-helped text-helped--copywriting-login-admin"
                  >You are logged in as admin, you can select and act as another user to review this product.</span
                >
                <div class="fieldarea fieldarea--multiselect">
                  <Multiselect
                    v-model="temp.fakeUser"
                    v-validate="'required'"
                    :options="options.fakeUser"
                    placeholder="Type to search user"
                    label="name"
                    track-by="name"
                    :loading="state.fakeUser.isLoading"
                    :show-labels="false"
                    open-direction="bottom"
                    :searchable="true"
                    :internal-search="false"
                    :clear-on-select="false"
                    :close-on-select="true"
                    :options-limit="300"
                    :max-height="600"
                    :show-no-results="false"
                    :hide-selected="true"
                    name="user"
                    @search-change="searchUser"
                  >
                    <span slot="noResult">User not found</span>
                  </Multiselect>
                </div>
                <p v-show="errors.has('user')" class="text-error">{{ errors.first('user') }}</p>
              </div>
            </div>
          </div>
          <div v-show="layerSteps.recommend" class="recommend-state">
            <div class="wallpaper"></div>
            <div class="average-rating-wrapper">
              <div class="average-rating">
                <h4 class="average-rating__heading">AVERAGE RATING</h4>
                <div class="average-rating__value">
                  <img v-if="averageRating" src="/assets/img/icons/rating-big.svg" alt="icon-rating" />
                  <img v-else src="/assets/img/icons/rating-big-disabled.svg" alt="icon-rating" />
                  {{ averageRating }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer">
          <template v-if="layerSteps.give_rating && !screen.isDesktop">
            <div v-if="allRating" class="average-rating-wrapper">
              <div class="average-rating">
                <h4 class="average-rating__heading">Your rating</h4>
                <div class="average-rating__bottom">
                  <div class="average-rating__caption">
                    {{ captionRating(averageRating) }}
                  </div>
                  <div class="average-rating__value">
                    <img v-if="averageRating" src="/assets/img/icons/rating-big.svg" alt="icon-rating" />
                    <img v-else src="/assets/img/icons/rating-big-disabled.svg" alt="icon-rating" />
                    {{ averageRating }}
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-if="layerSteps.write_review">
            <loader-spin v-if="!showModalConfirmationPublish && state.onProgressSubmit"></loader-spin>
            <a v-else href="" class="btn btn-next" :class="{ disabled: disabledNext }" @click.prevent="confirmation"
              >Publish</a
            >
          </template>
          <a v-else href="" class="btn btn-next" :class="{ disabled: disabledNext }" @click.prevent="nextStep">Next</a>
        </div>
      </GModal>
    </div>

    <ModalDiscard v-if="showModalDiscard" @discard="discardReview" />

    <ModalCombination v-show="showModalCombination" />

    <ModalError v-if="showModalError" :message="errorMessage" @close-modal="closeModalError" />

    <GModal v-if="showModalConfirmationPublish" class="modal--confirmation-publish">
      <div slot="header">
        <!-- <button type="button" class="close" aria-label="Close"><img src="/assets/img/icons/close-modal.svg" @click.prevent="closeConfirmation" /></button> -->

        <h2 class="modal-heading">Attention</h2>
      </div>

      <div slot="body">
        <p class="text">
          Periksa ulang yuk review yang sudah dibuat, karena setelah di publish kamu hanya dapat 1x kesempatan untuk
          mengedit review-mu!
        </p>
      </div>

      <div slot="footer">
        <div class="group-btn">
          <div class="col-btn">
            <a href="" class="btn btn-cancel btn-minimal" @click.prevent="closeConfirmation">Cancel</a>
          </div>
          <div class="col-btn">
            <a
              v-if="!state.onProgressSubmit"
              href=""
              class="btn btn-publish"
              @click.prevent="createReview"
              @keydown.prevent="createReview"
              >Publish</a
            >
            <a v-else class="btn btn-publish">Processing..</a>
          </div>
        </div>
      </div>
    </GModal>

    <GModal v-if="showModalPublishedReview" class="modal--published-review">
      <div slot="header">
        <div class="header">
          <SvgImg name="bubble-star" class="bubble-star__icon" width="80" height="64" />
          <p class="text">Review berhasil dipublish</p>
        </div>
      </div>
      <div slot="body">
        <span
          >Lengkapi Beauty Profile dan dapatkan <span class="points">150</span
          ><img src="/assets/img/icon-sp.svg" alt="SP" height="15" width="15" />
        </span>
        <p>
          Dengan melengkapi beauty profile, kamu akan mendapatkan rekomendasi produk dan konten yang sesuai dengan
          beauty profile kamu.
        </p>
      </div>
      <div slot="footer">
        <div class="btn red" @click="completeBeautyProfile">Complete Now!</div>
        <a href="" @click.prevent="reviewSuccess({ toast: false })">Complete Later</a>
      </div>
    </GModal>

    <GModal v-if="showModalTncPhoto" class="modal--tnc-photo">
      <div slot="header">
        <button type="button" class="close" aria-label="Close">
          <img src="/assets/img/icons/close-modal.svg" @click.prevent="closeTncPhoto" />
        </button>
        <h2 class="modal-heading">Term & Conditions</h2>
      </div>

      <div slot="body">
        <p class="text">Please provide information & photos about the reviewed product.</p>
        <p class="text"><strong>*Don't insert anything related to racism/ law violation</strong></p>
      </div>

      <div slot="footer">
        <div class="group-btn">
          <a href="" class="btn btn-publish" @click.prevent="closeTncPhoto">Ok</a>
        </div>
      </div>
    </GModal>
  </div>
</template>

<script>
let CancelToken;
let source;
import Multiselect from 'vue-multiselect';
import ReviewRating from './snippet/review-rating';
import ModalCombination from './snippet/modal-combination';
import ModalDiscard from './snippet/modal-discard';
import Compressor from 'compressorjs';
import ModalError from './snippet/modal-error';
import LoaderSpin from '@/shared/UIComponents/LoaderSpin';

export default {
  name: 'CreateReview',
  components: {
    Multiselect,
    ReviewRating,
    ModalCombination,
    ModalDiscard,
    ModalError,
    LoaderSpin,
  },
  beforeRouteLeave(to, from, next) {
    if (this.showModalCombination) {
      this.$store.commit('toggleModalGlobalState', { modalName: 'combination' });
    }
    next();
  },
  data() {
    return {
      layerSteps: {
        give_rating: true,
        write_review: false,
        recommend: false,
      },
      options: {
        tag: [],
        fakeUser: [],
      },
      temp: {
        contentReview: '',
        fakeUser: '',
        isRecomended: '',
        isRepurchase: '',
        combination: '',
        rating: {},
        tag: '',
        durationUsed: '',
      },
      isLoadingProduct: false,
      showModalError: false,
      errorMessage: '',
      state: {
        onProgressSubmit: false,
        tag: {
          isLoading: false,
        },
        fakeUser: {
          isLoading: false,
        },
      },
      openOnceTnc: false,
      defaultRatingTypes: ['is_star_effectiveness', 'is_star_packaging', 'is_star_texture', 'is_star_value_for_money'],
    };
  },
  computed: {
    allRating() {
      let isTrueTotal = 0;
      let length;

      if (!this.$SO.isEmptyObject(this.temp.rating)) {
        length = this.$SO.size(this.temp.rating);
        this.$SO.each(
          this.temp.rating,
          function (key, val) {
            if (this.temp.rating[key].value) {
              isTrueTotal++;
            }
          }.bind(this)
        );

        if (length === isTrueTotal) {
          return 'has data';
        } else {
          return '';
        }
      } else {
        return '';
      }
    },
    averageRating() {
      let total = 0;
      let length;

      if (!this.$SO.isEmptyObject(this.temp.rating)) {
        length = this.$SO.size(this.temp.rating);
        this.$SO.each(
          this.temp.rating,
          function (key, val) {
            if (this.temp.rating[key].value) {
              total += this.temp.rating[key].value;
            }
          }.bind(this)
        );

        if (total) {
          return (total / length).toFixed(1);
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    },
    copywritingHeadingMobile() {
      let copy = '';
      if (this.layerSteps.give_rating) {
        copy = 'Give Rating';
      } else if (this.layerSteps.write_review) {
        copy = 'Write Review';
      } else if (this.layerSteps.recommend) {
        copy = 'Recommend & Repurchase';
      }
      return copy;
    },
    disabledNext() {
      if (this.layerSteps.give_rating) {
        return !this.allRating;
      } else if (this.layerSteps.write_review) {
        return !this.temp.isRecomended || !this.temp.isRepurchase || !this.productShot;
      } else if (this.layerSteps.recommend) {
        return !this.temp.isRecomended || !this.temp.isRepurchase || !this.productShot;
      } else {
        return false;
      }
    },
    disabledPublishDesktop() {
      return Boolean(
        !this.allRating &&
          this.temp.contentReview.length < 150 &&
          !this.temp.isRecomended &&
          !this.temp.isRepurchase &&
          !this.temp.durationUsed
      );
    },
    editPhoto() {
      return this.$store.state.writeReview.editPhoto;
    },
    isAdminRole() {
      return this.user && this.user.role.includes('admin');
    },
    isLogin() {
      return this.$store.state.auth.loggedin;
    },
    pathEmojiRecomended() {
      if (this.temp.isRecomended === 'yes') {
        return `/assets/img/icons/yes-emoji.svg`;
      } else if (this.temp.isRecomended === 'no') {
        return `/assets/img/icons/no-emoji.svg`;
      } else {
        return `/assets/img/icons/default-recomendation-emoji.svg`;
      }
    },
    pathEmojiRepurchase() {
      if (this.temp.isRepurchase === 'yes') {
        return `/assets/img/icons/yes-emoji.svg`;
      } else if (this.temp.isRepurchase === 'maybe') {
        return `/assets/img/icons/maybe-emoji.svg`;
      } else if (this.temp.isRepurchase === 'no') {
        return `/assets/img/icons/no-emoji.svg`;
      } else {
        return `/assets/img/icons/default-recomendation-emoji.svg`;
      }
    },
    pathEmojiRecomendedYes() {
      if (this.temp.isRecomended === 'yes') {
        return `/assets/img/icons/icon-recommend-yes.svg`;
      } else {
        return `/assets/img/icons/icon-recommend-yes-gray.svg`;
      }
    },
    pathEmojiRecomendedNo() {
      if (this.temp.isRecomended === 'no') {
        return `/assets/img/icons/icon-recommend-no.svg`;
      } else {
        return `/assets/img/icons/icon-recommend-no-gray.svg`;
      }
    },
    pathEmojiRepurchaseYes() {
      if (this.temp.isRepurchase === 'yes') {
        return `/assets/img/icons/icon-recommend-yes.svg`;
      } else {
        return `/assets/img/icons/icon-recommend-yes-gray.svg`;
      }
    },
    pathEmojiRepurchaseNo() {
      if (this.temp.isRepurchase === 'no') {
        return `/assets/img/icons/icon-recommend-no.svg`;
      } else {
        return `/assets/img/icons/icon-recommend-no-gray.svg`;
      }
    },
    pathEmojiRepurchaseMaybe() {
      if (this.temp.isRepurchase === 'maybe') {
        return `/assets/img/icons/icon-recommend-maybe.svg`;
      } else {
        return `/assets/img/icons/icon-recommend-maybe-gray.svg`;
      }
    },
    productAttributes() {
      return this.$store.state.writeReview.productAttributes;
    },
    productCategory() {
      return this.$store.state.writeReview.productCategory || { rating_types: [] };
    },
    ratingTypes() {
      return this.productCategory.rating_types.length ? this.productCategory.rating_types : this.defaultRatingTypes;
    },
    productId() {
      return this.$route.params.product_id;
    },
    productSelected() {
      return this.$store.state.writeReview.selectedProduct;
    },
    haveUserPurchasedProduct() {
      if (this.$store.state.writeReview.selectedProduct) {
        return this.$store.state.writeReview.selectedProduct.combinations
          ? this.$store.state.writeReview.selectedProduct.combinations.some((combination) => {
              return combination.is_verified_purchase;
            })
          : false;
      }
      return false;
    },
    productShot() {
      return this.$store.state.writeReview.productShot;
    },
    showModalCombination() {
      return this.$store.state.modal.isModalShow.combination;
    },
    showModalConfirmationPublish() {
      return this.$store.state.modal.isModalShow.confirmationPublish;
    },
    showModalDiscard() {
      return this.$store.state.modal.isModalShow.discard;
    },
    showModalTncPhoto() {
      return this.$store.state.modal.isModalShow.tncPhoto;
    },
    user() {
      return this.$store.state.auth.userProfile;
    },
    queryStringCombinationId() {
      return this.$route.query.combination_id;
    },
    productCombinationsAttribute() {
      const combinations = this.productSelected ? this.productSelected.combinations : [];
      const combinedData = combinations.map((el) => {
        const variant = [];
        const attributeGroup = ['Shade', 'Variant', 'Size', 'Color', 'Non_specify'];

        if (el.attribute) {
          attributeGroup.forEach((group) => {
            const groupLower = group.toLowerCase();
            if (el.attribute[groupLower]) {
              variant.push({
                group,
                ...el.attribute[groupLower],
              });
            }
          });
        } else {
          attributeGroup.forEach((group) => {
            const groupLower = group.toLowerCase();
            if (el.attributes[groupLower]) {
              variant.push({
                group,
                ...el.attributes[groupLower],
              });
            }
          });
        }

        return {
          id: el._id,
          label: variant.map((attr) => attr.name).join(' - '),
          variant: variant.map((attr) => `${attr.group}: ${attr.name}`).join(', '),
          attribute: el.attribute ? el.attribute : el.attributes,
          is_active_in_review: el.is_active_in_review,
        };
      });
      // .filter((el) => el.label && el.is_active_in_review);

      return combinedData;
    },
    widthProgress() {
      let value = '';
      if (this.layerSteps.give_rating) {
        value = '60%';
      } else if (this.layerSteps.write_review) {
        value = '100%';
      } else if (this.layerSteps.recommend) {
        value = '100%';
      }
      return value;
    },
    captionProgress() {
      let caption = '';
      if (this.layerSteps.give_rating) {
        caption = '2 of 3';
      } else if (this.layerSteps.write_review) {
        caption = '3 of 3';
      } else if (this.layerSteps.recommend) {
        caption = '3 of 3';
      }
      return caption;
    },
    screen() {
      return this.$store.state.screen;
    },
    showModalPublishedReview() {
      return this.$store.state.modal.isModalShow.publishedReview;
    },
    notCompletedDetailProfile() {
      return !Boolean(
        this.user.hasOwnProperty('date_of_birth') &&
          this.user.hasOwnProperty('country') &&
          this.user.country.name &&
          this.user.hasOwnProperty('province') &&
          this.user.province.name
      );
    },
    notCompletedBeautyProfile() {
      return !Boolean(this.user.beauty && this.user.beauty.length);
    },
    temporaryProductShot() {
      return this.$store.state.writeReview.temporaryProductShot;
    },
    reviewData() {
      return this.$store.state.reviewData;
    },
    txtPlaceholder() {
      return `Tell us what you like about this product! \nFor example: Love this, it absorbs easily & gives that instant glowing effect! 😍`;
    },
    addReviewSource() {
      return this.$store.state.writeReview.addReviewSource;
    },
  },
  watch: {
    productCategory(newVal) {},
    isLogin: {
      handler(val) {
        if (val === false || val === '') {
          this.$store.commit('modalAuth', 1);
        } else {
          this.$store.commit('modalAuth', 0);
          const dontHaveParam = !this.$route.params.product_id && !this.$SO.size(this.selectedProduct);
          if (dontHaveParam) {
            this.$store.dispatch('setModalSearchProduct', true);
          } else {
            if (!this.$SO.size(this.productSelected) || this.productSelected.id !== this.productId) {
              this.isLoadingProduct = true;
              this.$store.commit('setSelectedProduct', '');
              this.$MS_SOCO_PUBLIC_API_URL(`products/${this.$route.params.product_id}`)
                .then((response) => {
                  if (response.status === 200) {
                    this.$store.dispatch('setDataSelectedProduct', {
                      dataSelectedProduct: response.data.data,
                      component: this,
                    });
                    this.$store.commit('setDataGlobalCombination', response.data.data);
                    if (this.productSelected.list_combinations.length) {
                      if (this.productSelected.list_combinations.length > 1 && !this.queryStringCombinationId) {
                        this.$store.commit('toggleModalGlobalState', { modalName: 'combination' });
                      } else if (this.productSelected.list_combinations.length > 1 && this.queryStringCombinationId) {
                        let storeKey;
                        this.productSelected.list_combinations.map((combination, key) => {
                          if (combination['_id'] === this.queryStringCombinationId) {
                            storeKey = key;
                          }
                        });
                        this.$store.commit('addKeyToSelectedProduct', {
                          key: 'selected_combination',
                          value: this.productSelected.list_combinations[storeKey],
                        });
                      } else {
                        // automatic select when product has one attribute
                        this.$store.commit('addKeyToSelectedProduct', {
                          key: 'selected_combination',
                          value: this.productSelected.list_combinations[0],
                        });
                      }
                    }
                  } else {
                    this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
                  }
                  this.isLoadingProduct = false;
                })
                .catch((err) => {
                  console.error(err);
                  this.isLoadingProduct = false;
                  this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
                });
            }
          }
        }
      },
      immediate: true,
    },
    productCategory() {
      if (this.$SO.size(this.productCategory)) {
        const createTempForRating = {};
        this.$SO.each(this.productCategory.rating_types, (key, ratingName) => {
          createTempForRating[ratingName] = { value: 0 };
        });
        this.temp.rating = createTempForRating;
      }
    },
    productSelected(newProductSelected, oldProductSelected) {
      if (this.$SO.size(newProductSelected) && newProductSelected.id != oldProductSelected.id) {
        if (this.queryStringCombinationId === '') {
          this.$router.push(`/review/add/${this.productSelected.id}`);
        }

        this.$store.commit('setDataGlobalCombination', this.productSelected);
        if (this.productSelected.list_combinations.length) {
          if (this.productSelected.list_combinations.length > 1 && this.queryStringCombinationId) {
            let storeKey;
            this.productSelected.list_combinations.map((combination, key) => {
              if (combination['_id'] === this.queryStringCombinationId) {
                storeKey = key;
              }
            });
            this.$store.commit('addKeyToSelectedProduct', {
              key: 'selected_combination',
              value: this.productSelected.list_combinations[storeKey],
            });
          } else {
            // automatic select when product has one attribute
            this.$store.commit('addKeyToSelectedProduct', {
              key: 'selected_combination',
              value: this.productSelected.list_combinations[0],
            });
          }
        }
      } else if (this.$SO.size(newProductSelected) && newProductSelected.id === oldProductSelected.id) {
        this.$store.commit('setDataGlobalCombination', newProductSelected);
        if (this.productSelected.list_combinations.length) {
          if (this.productSelected.list_combinations.length > 1) {
            this.$store.commit('toggleModalGlobalState', { modalName: 'combination' });
          } else {
            // automatic select when product has one attribute
            this.$store.commit('addKeyToSelectedProduct', {
              key: 'selected_combination',
              value: this.productSelected.list_combinations[0],
            });
          }
        }
      }
    },
  },
  created() {
    this.clearForm();
    // var dontHaveParam = !this.$route.params.product_id && !this.$SO.size(this.selectedProduct);

    this.temp.fakeUser = this.user;
    this.productCategory;
  },
  updated() {
    this.toggleHeightMultiselect();
  },
  beforeDestroy() {
    this.$store.commit('resetDataRelatedWriteReview');
    this.$store.dispatch('setModalSearchProduct', false);
    if (this.showModalPublishedReview) {
      this.togglePublishedReview();
    }
  },
  methods: {
    onInputContentReview(evt) {
      const value = evt.target.value || '';
      let modifiedValue = value.replace(/(.)\1{5,}/g, (match, char) => char.repeat(5));
      modifiedValue = modifiedValue.replace(/\n{3,}/g, '\n\n');
      if (value !== modifiedValue) {
        this.temp.contentReview = modifiedValue;
      }
    },
    convertName(title) {
      if (!title) {
        return '';
      }
      let name = title;
      const word_length = 72;
      if (name.toString().length >= word_length) {
        name = name.toString().substr(0, word_length) + '...';
      }
      return name;
    },
    captionRating(rating) {
      const r = Number(rating);
      switch (true) {
        case r >= 1.0 && r <= 1.9:
          return 'It’s Not For Me!';
        case r >= 2.0 && r <= 2.9:
          return 'Doesn’t Meet Expectation!';
        case r >= 3.0 && r <= 3.9:
          return 'Just Okay!';
        case r >= 4.0 && r <= 4.9:
          return 'Excellent product!';
        case r === 5.0:
          return 'Ultimate holy-grail!';
        default:
          return '';
      }
    },
    onSelected() {
      this.$nextTick(() => this.$refs.multiselect.$el.focus());
    },
    closeConfirmation() {
      if (this.showModalConfirmationPublish) {
        this.$store.commit('toggleModalGlobalState', { modalName: 'confirmationPublish' });
      }
    },
    closeTncPhoto() {
      if (this.showModalTncPhoto) {
        this.$store.commit('toggleModalGlobalState', { modalName: 'tncPhoto' });
      }
    },
    clearForm() {
      this.temp.attributes = {};
      this.temp.rating = {};
      this.temp.isRecomended = '';
      this.temp.isRepurchase = '';
      this.temp.contentReview = '';
      this.temp.tag = '';
      this.$store.commit('resetDataRelatedWriteReview');
      this.closeModalError();
    },
    closeModalError() {
      this.showModalError = false;
      this.errorMessage = '';
    },
    discardReview() {
      this.$store.dispatch('setModalSearchProduct', true);
      this.clearForm();
      this.$validator.reset();
    },
    confirmation() {
      if (this.user.is_expert_reviewer) {
        this.createReview();
      } else {
        this.$store.commit('toggleModalGlobalState', { modalName: 'confirmationPublish' });
      }
    },
    togglePublishedReview() {
      this.$store.commit('toggleModalGlobalState', { modalName: 'publishedReview' });
    },
    confirmationRemovePhoto(key) {
      this.$store.commit('setSavedKeyRemovePhoto', key);
      this.$store.commit('toggleModalGlobalState', { modalName: 'confirmationPhoto' });
    },
    createReview() {
      let payload;

      this.state.onProgressSubmit = true;

      this.$validator
        .validateAll()
        .then((response) => {
          if (!response) {
            this.state.onProgressSubmit = false;
            if (document.getElementById(this.$validator.errors.items[0].field)) {
              document.getElementById(this.$validator.errors.items[0].field).scrollIntoView();
              window.scrollBy(0, -85);
            }
            return false;
          }
        })
        .then((response) => {
          payload = {
            source: window.innerWidth > 1100 ? 'review-web-desktop' : 'review-web-mobile',
            product_id: this.productSelected.id,
            details: this.temp.contentReview,
            is_recommended: this.temp.isRecomended,
            is_repurchase: this.temp.isRepurchase,
            images: [],
            product: {
              id: this.productSelected.id,
              combination: '',
            },
            tags: [],
            duration_of_used: this.temp.durationUsed ? this.temp.durationUsed : undefined,
          };

          if (this.$SO.size(this.productSelected.selected_combination)) {
            this.$SO.each(this.productCombinationsAttribute, (key, combination) => {
              if (combination.id === this.productSelected.selected_combination['_id']) {
                payload.product.combination = this.productCombinationsAttribute[key];
                return false;
              }
            });
          } else {
            this.$SO.each(this.productSelected.combinations, (key, combination) => {
              if (combination.is_default === true) {
                const combinedData = this.productSelected.combinations.map((el) => {
                  const variant = [];
                  const attributeGroup = ['Shade', 'Variant', 'Size', 'Color', 'Non_specify'];
                  attributeGroup.forEach((group) => {
                    const groupLower = group.toLowerCase();
                    if (el.attributes[groupLower]) {
                      variant.push({
                        group,
                        ...el.attributes[groupLower],
                      });
                    }
                  });

                  return {
                    id: el._id,
                    label: variant.map((attr) => attr.name).join(' - '),
                    variant: variant.map((attr) => `${attr.group}: ${attr.name}`).join(', '),
                    attribute: el.attribute ? el.attribute : el.attributes,
                    is_active_in_review: el.is_active_in_review,
                  };
                });

                payload.product.combination = combinedData[key];
                return false;
              }
            });
          }

          payload.product.variant = payload.product.combination ? payload.product.combination.variant : '';

          if (this.$SO.size(this.productShot)) {
            this.$SO.each(this.productShot, (key, objProduct) => {
              if (objProduct.file) {
                payload.images.push({
                  name: objProduct.file,
                  description: objProduct.caption,
                });
              }
            });
          }

          if (this.$SO.size(this.temp.fakeUser)) {
            payload.user = {
              id: this.temp.fakeUser['_id'],
              username: this.temp.fakeUser.user_name,
              name: `${this.temp.fakeUser.first_name} ${this.temp.fakeUser.last_name}`,
            };
          }

          this.$SO.each(this.temp.tag, (i, tag) => {
            payload.tags.push({ name: tag.name });
          });

          this.$SO.each(this.temp.rating, (key, prop) => {
            payload[key] = this.temp.rating[key].value;
          });

          if (payload.images.length == 0) {
            delete payload.images;
          }

          this.$MS_SOCO_PUBLIC_API_URL
            .post('reviews', payload)
            .then(async (newReview) => {
              if (newReview.status == '200') {
                if (this.notCompletedBeautyProfile || this.notCompletedDetailProfile || !this.user.is_expert_reviewer) {
                  this.closeConfirmation();
                  this.togglePublishedReview();
                  this.$route.query.origin === 'pdp' ? this.$router.go(-1) : null;
                  return;
                }
                if (this.user.is_expert_reviewer) {
                  // Set Review Data
                  const reviewDataPayload = { ...newReview.data.data };
                  reviewDataPayload.product.images = this.productSelected.images;
                  this.$SO('body').addClass('no-scroll');
                  this.$store.commit('setReviewData', reviewDataPayload);

                  // Get Share Template WhatsApp & Facebook
                  Promise.all([this.getShareTemplate('wa'), this.getShareTemplate('fb')])
                    // Convert All Base64 to Blob
                    .then((arrB64) => arrB64.map((b64) => this.dataURItoBlob(b64)))
                    // Pre Sign all Blobs
                    .then((fileBlobs) => {
                      delete axios.defaults.withCredentials;

                      return Promise.all(
                        fileBlobs.map((fileBlob) =>
                          this.preSignBaseImage(fileBlob)
                            .then(({ data: { data: preSigned } }) => ({
                              fileBlob,
                              preSigned,
                            }))
                            .catch((error) => {
                              console.error('Error in pre-signing blob:', error);
                              throw new Error('preSignError'); // Throw to catch in final block
                            })
                        )
                      );
                    })
                    // Upload all blob to s3
                    .then((res) => {
                      return Promise.all(
                        res.map((e) =>
                          this.uploadTemplate(e.preSigned.signedUrl, e.fileBlob)
                            .then(() => e)
                            .catch((error) => {
                              console.error('Error in uploading to S3:', error);
                              throw new Error('uploadError'); // Throw to catch in final block
                            })
                        )
                      );
                    })
                    // Assign share template to review
                    .then((arr) => {
                      const [wa, fb] = arr;
                      const urlWa = wa.preSigned.url;
                      const urlFb = fb.preSigned.url;

                      return this.updateReviewShareTemplate(newReview.data.data, urlWa, urlFb)
                        .then(() => arr)
                        .catch((error) => {
                          console.error('Error in updating review share template:', error);
                          throw new Error('updateError'); // Throw to catch in final block
                        });
                    })
                    .catch((error) => {
                      console.error('Error occurred:', error);
                    })
                    .finally(() => {
                      axios.defaults.withCredentials = true;
                      this.$SO('body').removeClass('no-scroll');
                      this.$store.commit('setReviewData', {});
                      this.reviewSuccess({ toast: true });
                      this.$route.query.origin === 'pdp' ? this.$router.go(-1) : null;
                    });
                } else {
                  this.reviewSuccess({ toast: true });
                  this.$route.query.origin === 'pdp' ? this.$router.go(-1) : null;
                }
              } else {
                if (newReview.status == '403') {
                  if (newReview.data.errorCode) {
                    this.$toasted.global.error(newReview.data.errorCode);
                  } else {
                    this.$toasted.global.error('Konten review yang ingin kamu masukkan sudah ada.');
                  }
                } else {
                  this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
                }
                this.state.onProgressSubmit = false;
              }
              if (!this.user.is_expert_reviewer || this.$store.state.modal.isModalShow.confirmationPublish) {
                this.closeConfirmation();
              }
            })
            .catch((error) => {
              if (error.response) {
                if (error.response && error.response.data && error.response.data.message) {
                  if (error.response.data.errorCode == 'DUPLICATE_USER_REVIEW') {
                    this.showModalError = true;
                    this.errorMessage =
                      'Maaf, Kamu sudah pernah review produk atau produk dengan kombinasi ini sebelumnya.';
                  } else if (error.response.data.errorCode == 'ERR_PRODUCT_NOT_FOUND') {
                    this.showModalError = true;
                    this.errorMessage = 'Hai, kamu gagal mengirim review sebanyak 3x. Coba lagi dalam satu jam.';
                  } else {
                    this.showModalError = true;
                    this.errorMessage = error.response.data.message;
                  }
                } else if (error.response.status == 403) {
                  if (error.response.data.errorCode) {
                    this.$toasted.global.error(error.response.data.errorCode);
                  } else {
                    this.$toasted.global.error('Konten review yang ingin kamu masukkan sudah ada.');
                  }
                } else {
                  this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
                }
              } else {
                this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
              }
              this.state.onProgressSubmit = false;
              this.closeConfirmation();
            });
        })
        .catch((error) => {
          this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
          this.state.onProgressSubmit = false;
          this.closeConfirmation();
        });
    },
    getShareTemplate(type = 'wa') {
      return this.$store.dispatch('getShareTemplate', { type });
    },
    preSignBaseImage(fileBlob) {
      const filename = Math.floor(100000000000 * Math.random());
      return this.$MS_SOCO_PUBLIC_API_URL(`pre-signed-url`, {
        params: {
          fileName: `${filename}.${fileBlob.type.replace('image/', '')}`,
          contentType: fileBlob.type,
        },
      });
    },
    updateReviewShareTemplate(reviewData, whatsapp, facebook) {
      return this.$MS_SOCO_PUBLIC_API_URL.put(`reviews/${reviewData._id}`, {
        ...reviewData,
        share_image: { whatsapp, facebook },
      });
    },
    uploadTemplate(signedUrl, fileBlob) {
      return fetch(signedUrl, {
        method: 'PUT',
        headers: { 'Content-Type': fileBlob.type },
        body: fileBlob,
      });
    },
    editProductShot(productShotKey) {
      const selected = this.$store.state.writeReview.productShot[productShotKey];
      this.$store.commit('setEditPhotoPropertyOf', { name: 'file', value: selected.file });
      this.$store.commit('setEditPhotoPropertyOf', { name: 'caption', value: selected.caption });

      this.$store.dispatch('setModalEditPhoto', { newValModal: true, productShotKey: productShotKey });
    },
    openModal() {
      this.$store.dispatch('setModalSearchProduct', true);
    },
    openModalUploadPhoto() {
      this.$store.dispatch('setModalUploadPhoto', true);
    },
    searchTag(keyword) {
      if (!keyword || keyword.length < 3) {
        if (typeof source !== 'undefined') {
          this.state.tag.isLoading = false;
          source.cancel();
        }
        return;
      }

      if (typeof source !== 'undefined') {
        source.cancel(false);
      }
      CancelToken = axios.CancelToken;
      source = CancelToken.source();

      this.state.tag.isLoading = true;
      this.$MS_SOCO_PUBLIC_API_URL('product/tags', {
        params: {
          keyword: keyword,
          skip: 0,
          limit: 10,
        },
      })
        .then(
          function (response) {
            if (response.status == 200) {
              this.options.tag = response.data.data;
              this.state.tag.isLoading = false;
            }
          }.bind(this)
        )
        .catch(
          function (error) {
            if (axios.isCancel(error)) {
              return true;
            } else {
              console.error(error);
              // if(this.$store.state.consoleLogMode){console.log('Error: ' + error)}
            }
          }.bind(this)
        );
    },
    searchUser(keyword) {
      if (!keyword || keyword.length < 3) {
        if (typeof source !== 'undefined') {
          this.state.tag.isLoading = false;
          source.cancel();
        }
        return;
      }

      if (typeof source !== 'undefined') {
        source.cancel(false);
      }
      CancelToken = axios.CancelToken;
      source = CancelToken.source();

      this.state.fakeUser.isLoading = true;

      this.$MS_SOCO_PUBLIC_API_URL
        .get(`/search?keyword=${keyword}`, {
          params: {
            skip: 0,
            limit: 10,
          },
          cancelToken: source.token,
        })
        .then((response) => {
          if (response.status === 200) {
            this.options.fakeUser = response.data.data;
          }
          this.state.fakeUser.isLoading = false;
        })
        .catch((err) => {
          //if (err.message !== false) this.state.fakeUser.isLoading = false
        });
    },
    setRating(options) {
      if (!this.temp.rating[options.name]) {
        this.$set(this.temp.rating, options.name, { value: 0 });
      }
      this.temp.rating[options.name].value = options.value;
    },
    toggleHeightMultiselect() {
      const $fieldMultiselectSuggestion = this.$SO('.fieldarea--multiselect--tag .multiselect__content-wrapper');
      const $fieldMultiselectEl = this.$SO('.fieldarea--multiselect--tag');
      const height = this.$SO('.fieldarea--multiselect--tag .multiselect__tags-wrap').length
        ? this.$SO('.fieldarea--multiselect--tag .multiselect__tags-wrap')[0].offsetHeight + 20
        : 0;

      $fieldMultiselectSuggestion.css({ marginTop: height });
      $fieldMultiselectEl.css({ marginBottom: height });
    },
    backStep() {
      if (this.addReviewSource !== 'dashboard') {
        if (this.layerSteps.give_rating) {
          if (this.allRating) {
            this.$store.commit('toggleModalGlobalState', { modalName: 'discard' });
            return;
          }
          this.$store.dispatch('setModalSearchProduct', true);
        } else if (this.layerSteps.write_review) {
          this.layerSteps.write_review = false;
          this.layerSteps.give_rating = true;
        } else if (this.layerSteps.recommend) {
          this.layerSteps.recommend = false;
          this.layerSteps.write_review = true;
        }
      } else {
        if (this.layerSteps.give_rating) {
          if (this.screen.isDesktop) {
            this.$router.go(-1);
          } else {
            if (this.allRating) {
              this.$store.commit('toggleModalGlobalState', { modalName: 'discard' });
              return;
            }
            this.clearForm();
            this.$validator.reset();
            this.$router.go(-1);
          }
        } else if (this.layerSteps.write_review) {
          this.layerSteps.write_review = false;
          this.layerSteps.give_rating = true;
        } else if (this.layerSteps.recommend) {
          this.layerSteps.recommend = false;
          this.layerSteps.write_review = true;
        }
      }
    },
    nextStep() {
      if (this.layerSteps.give_rating) {
        this.layerSteps.give_rating = false;
        this.layerSteps.write_review = true;
      } else if (this.layerSteps.write_review) {
        this.layerSteps.write_review = false;
        this.layerSteps.recommend = true;
      }
    },
    reviewSuccess({ toast }) {
      if (toast) {
        this.$toasted.global.show('Review kamu berhasil dipublish.');
      } else {
        this.$MS_ANALYTICS_API_URL.post(`/sessions/me/`, {
          user_id: this.temp.fakeUser['_id'],
          user_name: this.temp.fakeUser.user_name,
          events: {
            verb: 'skip',
            object_type: 'beauty_profile',
            referrer: 'add_review',
          },
        });
      }
      this.state.onProgressSubmit = false;
      this.$store.commit('toggleModalGlobalState', { modalName: 'shareExperience' });
      this.$router.push(`/`);
    },
    completeBeautyProfile() {
      this.$SO('body').removeClass('no-scroll');
      this.togglePublishedReview();
      this.$MS_ANALYTICS_API_URL.post(`/sessions/me/`, {
        user_id: this.temp.fakeUser['_id'],
        user_name: this.temp.fakeUser.user_name,
        events: {
          verb: 'add',
          object_type: 'beauty_profile',
          referrer: 'add_review',
        },
      });
      this.$router.push(this.notCompletedDetailProfile ? '/register-detail' : '/beauty-profile');
    },
    onProcessFile(e) {
      const files = e.target.files;
      for (let i = 0; i < files.length; i++) {
        this.validationFile(files[i], files.length);
        this.openModalUploadPhoto();
      }
    },
    validationFile(file, totalFiles = 1) {
      const totalMaxFile = 6;
      const isReachTotalMaxFile =
        this.productShot.length + totalFiles + this.temporaryProductShot.length > totalMaxFile;

      if (file) {
        if (file.size < 5242880 && /png|jpg|jpeg/.test(file.type) && !isReachTotalMaxFile) {
          const self = this;
          new Compressor(file, {
            height: 600,
            width: 600,
            mimeType: 'image/png',
            quality: 0.8,
            success(fileAfterCompress) {
              self.fileToBase64(fileAfterCompress);
            },
            error(e) {
              console.error(e.message);
            },
          });

          this.errorUploadPhoto = false;
          this.messageErrorUploadPhoto = '';
        }

        if (!(file.size < 5242880)) {
          this.errorUploadPhoto = true;
          this.messageErrorUploadPhoto = 'Ukuran maksimum 5MB';
        }

        if (!/png|jpg|jpeg/.test(file.type)) {
          this.errorUploadPhoto = true;
          this.messageErrorUploadPhoto = 'File harus png, jpg, jpeg.';
        }

        if (isReachTotalMaxFile) {
          this.errorUploadPhoto = true;
          this.messageErrorUploadPhoto = 'File yang akan anda upload telah mencapai batas maksimal 6';
        }
      }
    },
    dataURItoBlob(dataURI) {
      const arr = dataURI.split(',');
      const mime = arr[0] && arr[0].match(/:(.*?);/) && arr[0].match(/:(.*?);/)[1];
      const byteString = atob(dataURI.split(',')[1]);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ab], { type: mime });
    },
    fileToBase64(file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        this.$store.dispatch('addDataTemporaryProductShot', reader.result);
      }.bind(this);
      reader.onerror = function (error) {
        console.error(error);
      };
    },
    openTncPhoto() {
      this.$store.commit('toggleModalGlobalState', { modalName: 'tncPhoto' });
      this.openOnceTnc = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-small {
  font-size: 13px;
}
.m-b-16 {
  margin-bottom: 16px;
  font: 13px 'lato-regular', sans-serif;
}
.p-0 {
  padding: 0;
}
.p-16 {
  padding: 0 16px;
}
.p-bottom-90 {
  padding-bottom: 90px;
}
.form-group .input-mandatory {
  display: none;
}
.trusted-review {
  position: absolute;
  right: 16px;
  top: 10px;

  @media (max-width: 740px) {
    top: 10px;
  }

  .trusted-review__text {
    font: 12px 'lato-bold', sans-serif;
    letter-spacing: normal;
    color: #828282;
    @media (max-width: 740px) {
      font: 10px 'lato-bold', sans-serif;
    }
  }
  .trusted-review__icon {
    vertical-align: middle;
    margin-right: 5px;
  }
}
</style>
